import { canCompanyBulkCreate, canAccessPaymentCardCreate, canAccessPaymentCardCreatePlan, canAccessAiAssistant } from '@/utils/conditions';
import { IAccessPermission } from '@/types/middleware/routeAccessPermissions';
import { OPERATION_PERMISSIONS } from '@/configs/enums/permissions';
import { RESPONSE_CODE } from '@/configs/http';
import { USER_TYPE } from '@/configs';

/** アクセス権限の定義 */
export const routeAccessPermissions: IAccessPermission[] = [
  {
    /**
     * ホームページ管理
     * - /mypage/setting/website
     * - /mypage/setting/website/access
     */
    routePath: /^\/mypage\/setting\/website(?:\/access)?\/?$/,
    item: {
      accessCondition: {
        permissions: [
          OPERATION_PERMISSIONS.COMPANY_SETTING_WEBSITE_WRITE
        ],
        allowedUserTypes: []
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * マッチング検索
     * - /mypage/matching/search で始まる場合
     */
    routePath: /^\/mypage\/matching\/search/,
    item: {
      accessCondition: {
        permissions: [
          OPERATION_PERMISSIONS.COMPANY_SETTING_MATCHING_WRITE,
          OPERATION_PERMISSIONS.COMPANY_SETTING_COMPANY_WRITE,
          OPERATION_PERMISSIONS.COMPANY_MATCHING_READ
        ],
        allowedUserTypes: []
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * 企業一括作成
     * - /admin/company/bulk-create
     * - /admin/company/bulk-create/
     */
    routePath: /^\/admin\/company\/bulk-create\/?$/,
    item: {
      customAccessCondition: {
        canAccess: canCompanyBulkCreate
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.NOT_FOUND.statusCode,
      errorMessage: RESPONSE_CODE.NOT_FOUND.message
    }
  },
  {
    /**
     * 商談管理
     * - /mypage/matching/received_history で始まる場合
     */
    routePath: /^\/mypage\/matching\/received_history/,
    item: {
      accessCondition: {
        permissions: [
          OPERATION_PERMISSIONS.COMPANY_MATCHING_READ
        ],
        allowedUserTypes: []
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * 商談申込履歴
     * - /mypage/matching/history で始まる場合
     */
    routePath: /^\/mypage\/matching\/history/,
    item: {
      accessCondition: {
        permissions: [
          OPERATION_PERMISSIONS.COMPANY_MATCHING_READ
        ],
        allowedUserTypes: [
          USER_TYPE.OWNER,
          USER_TYPE.USER
        ]
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * 企業登録申請詳細
     * - /admin/companyregister/detail/xxxxxxx で始まる場合
     */
    routePath: /^\/admin\/companyregister\/detail\/[^/]+$/,
    item: {
      accessCondition: {
        permissions: [],
        allowedUserTypes: [
          USER_TYPE.SYSTEM_ADMIN,
          USER_TYPE.BANK_ADMIN
        ]
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * メルマガ一覧
     * - /admin/newsletter で始まる場合
     */
    routePath: /^\/admin\/newsletter/,
    item: {
      accessCondition: {
        permissions: [],
        allowedUserTypes: [
          USER_TYPE.SYSTEM_ADMIN,
          USER_TYPE.BANK_ADMIN
        ]
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * メルマガ詳細
     * - /admin/newsletter/detail/xxxxxxx で始まる場合
     */
    routePath: /^\/admin\/newsletter\/detail\/[^/]+$/,
    item: {
      accessCondition: {
        permissions: [],
        allowedUserTypes: [
          USER_TYPE.SYSTEM_ADMIN,
          USER_TYPE.BANK_ADMIN
        ]
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * メルマガ配信対象設定
     * - /admin/newsletter/target/xxxxxxx で始まる場合
     */
    routePath: /^\/admin\/newsletter\/target\/[^/]+$/,
    item: {
      accessCondition: {
        permissions: [],
        allowedUserTypes: [
          USER_TYPE.SYSTEM_ADMIN,
          USER_TYPE.BANK_ADMIN
        ]
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * お支払い設定画面
     * - /mypage/payment/card/create
     */
    routePath: /^\/mypage\/payment\/card\/create\/?$/,
    item: {
      customAccessCondition: {
        canAccess: canAccessPaymentCardCreate
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * 契約プランの変更画面
     * - /mypage/payment/card/create/plan
     */
    routePath: /^\/mypage\/payment\/card\/create\/plan\/?$/,
    item: {
      customAccessCondition: {
        canAccess: canAccessPaymentCardCreatePlan
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  },
  {
    /**
     * BiBi（AIアシスタント）
     * - /mypage/matching/aiassistant
     */
    routePath: /^\/mypage\/matching\/aiassistant/,
    item: {
      customAccessCondition: {
        canAccess: canAccessAiAssistant
      }
    },
    errorInfo: {
      statusCode: RESPONSE_CODE.FORBIDDEN.statusCode,
      errorMessage: RESPONSE_CODE.FORBIDDEN.message
    }
  }
];
